import normalizeUrl from 'normalize-url'

export const normalizeDomain = (domain: string) => {
  const { hostname } = new URL(normalizeUrl(domain, { stripWWW: true }))

  return hostname
}
